<!-- 分配评审专家 -->
<template>
  <div id="distributionSpecialist">
    <div class="overhad">
      <!-- 页面标题 -->
      <div class="title_page">分配评审专家</div>
      <div class="info">
        <div class="gray flexStart">
          <div>评审用户</div>
          <div>{{ detailItem.userName || '-' }}</div>
        </div>
        <div class="gray flexStart">
          <div>目前所涉及的行业</div>
          <div>{{ detailItem.category || '-' }}</div>
        </div>
      </div>
      <el-row :gutter="20" class="content" v-loading="loading" element-loading-text="拼命加载中">
        <!-- 模块列表 -->
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="overflow: auto">
          <div class="header flexBetween">模块列表</div>
          <div class="card_model" :class="[{ active: model.id == selectedModel.id }]" v-for="(model, m) in detailItem.modelList" :key="m" @click="changeModel(model)">
            <div v-if="model.expert && model.expert.id == selectedMain.id" class="main">主审专家</div>
            <div class="title nowrap">{{ model.name }}</div>
            <div v-if="model.expert" class="flexStart">
              <img :src="model.expert.workPhoto" />
              <div>
                <div class="theme nowrap">{{ model.expert.expertName }}</div>
                <div class="gray nowrap">{{ model.expert.category }}</div>
              </div>
            </div>
            <div v-else-if="model.id == selectedModel.id" class="flexStart">
              <div class="blacklogo"></div>
              <div class="blue_tips">请在右侧专家列表中选择评审专家</div>
            </div>
            <div v-else class="gray">等待选择评审专家</div>
          </div>
          <div style="text-align: center">
            <el-button type="primary" plain @click="setMain()">将所选模块专家设为主审专家</el-button>
          </div>
        </el-col>
        <!-- 专家列表 -->
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <!-- 头部标题&按钮 -->
          <div class="header flexBetween">
            <div class="opts_table">专家列表</div>
            <div class="opts_table">
              <!-- 模糊查询 -->
              <!-- 性别 -->
              <el-select v-model="selected_sex" multiple placeholder="性别" size="small" :popper-append-to-body="false" clearable @change="getTableData">
                <el-option v-for="item in sexList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-cascader
                ref="industrysList"
                v-model="selected_industrys"
                :options="industrysList"
                :props="props_cascader"
                clearable
                @change="getTableData"
                placeholder="目前所涉及的行业"
                size="small"
                style="max-width: 120px"></el-cascader>
              <!-- 职称 -->
              <el-select v-model="selected_rank" multiple placeholder="职称" size="small" :popper-append-to-body="false" clearable @change="getTableData">
                <el-option v-for="item in rankList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <!-- 擅长模块 -->
              <el-select v-model="selected_adepts" multiple placeholder="擅长模块" size="small" :popper-append-to-body="false" clearable @change="getTableData">
                <el-option v-for="item in modelList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-input
                placeholder="请输入内容"
                prefix-icon="el-icon-search"
                v-model="queryParam.keyWords"
                size="small"
                clearable
                @change="getTableData"
                @keyup.enter.native="getTableData"
                style="width: 180px"></el-input>
            </div>
          </div>
          <!-- 列表 -->
          <div class="table">
            <el-table :data="tableData" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table" @row-click="rowClick" @sort-change="handleSortChange">
              <el-table-column
                v-for="(item, i) in tableKeys_current"
                :key="i"
                :prop="item.key"
                :label="item.title"
                :sortable="item.sortable ? 'custom' : false"
                show-overflow-tooltip
                :min-width="item.width ? item.width : ''"
                :align="item.align ?? 'center'">
                <template slot-scope="props">
                  <div v-if="item.type == 'status'" :class="item.class_status ? item.class_status[props.row[item.key]] : ''">
                    {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
                  </div>
                  <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}` }}</div>
                  <div v-else-if="item.type == 'time'" class="nowrap">{{ props.row[item.key] ? moment(props.row[item.key]).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
                  <div v-else class="nowrap">{{ props.row[item.key] ? props.row[item.key] : '--' }}</div>
                </template>
              </el-table-column>
              <el-table-column label="选择专家" fixed="right" width="150" align="center">
                <template slot-scope="props">
                  <div class="flexNormal">
                    <div v-if="selectedExpert.id == props.row.id" class="checkedIcon"><i class="el-icon-check"></i></div>
                    <div v-else-if="selected_experts.includes(props.row)" class="grayIcon"></div>
                  </div>
                </template>
              </el-table-column>
              <div slot="empty">
                <img src="../../assets/img/emptyData.png" alt="" />
              </div>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="pagination" style="margin-bottom: 100px">
            <div v-show="InnerWH.width > 450">共{{ total }}条数据</div>
            <el-pagination
              hide-on-single-page
              background
              @current-change="handleCurrentChange"
              :current-page.sync="queryParam.page"
              :page-size="10"
              :pager-count="5"
              :layout="InnerWH.width > 450 ? 'prev, pager, next, jumper' : 'prev, pager, next'"
              :total="total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="absoluteGrop">
      <el-button type="primary" @click="submitDistribution()">确认分配</el-button>
      <el-button plain @click="$router.go(-1)">取 消</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'distributionSpecialist',
  components: {},
  data() {
    return {
      loading: false,
      moment: moment,
      detailItem: { modelList: [] },
      // 列表查询传参
      queryParam: {
        keyWords: '',
        page: 1,
        limit: 10,
      },
      // 列表字段合集
      tableKeys_current: [
        { title: '专家姓名', key: 'expertName', width: 150 },
        { title: '年龄', key: 'age', width: 150, sortable: true },
        { title: '专家性别', key: 'gender', type: 'status', text_status: ['', '男', '女'], width: 150 },
        { title: '目前所涉及的行业', key: 'category', width: 150 },
        { title: '专家职称级别', key: 'rank', width: 150, type: 'status', text_status: ['', '初级职称', '中级职称', '高级职称'], sortable: true },
        { title: '擅长模块', key: 'adeptsInfo', width: 150 },
        { title: '参与评审次数', key: 'number', width: 150, sortable: true },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      industrysList: [],
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      rankList: [
        { name: '初级职称', id: 1 },
        { name: '中级职称', id: 2 },
        { name: '副高级职称', id: 3 },
        { name: '正高级职称', id: 4 },
      ],
      modelList: [
        { name: '组织保障', id: 1 },
        { name: '三基建设', id: 2 },
        { name: '人机精细化管理', id: 3 },
        { name: '改善与创新', id: 4 },
      ],
      sexList: [
        { name: '男', id: 1 },
        { name: '女', id: 2 },
      ],
      selected_industrys: [],
      selected_sex: [],
      selected_rank: [],
      selected_adepts: [],
      selectedModel: {}, //选中模块
      selectedMain: {}, //主审专家
      selectedExpert: {}, //当前选中专家
      selected_experts: [], //已选择专家合集
    };
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  created() {
    this.getIndustryTypes();
    this.getTableData();
    this.getInfo();
  },
  mounted() {},
  methods: {
    //获取目前所涉及的行业
    getIndustryTypes() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.industrysList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: 'error',
              message: '查询失败-' + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取评审详情
    getInfo() {
      this.loading = true;
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/userRecordInfo`, { id: this.$route.query.recordId })
        .then((res) => {
          if (res.data.code == 200) {
            this.detailItem = res.data.data;
            this.getModel();
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getModel() {
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/moduleList`, { id: this.$route.query.recordId })
        .then((res) => {
          if (res.data.code == 200) {
            this.$set(this.detailItem, 'modelList', res.data.data);
            this.selectedModel = JSON.parse(JSON.stringify(res.data.data[0]));
            this.loading = false;
          } else {
            this.loading = false;
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    //
    //获取专家列表数据
    getTableData() {
      let keys_param = ['sex', 'industrys', 'rank', 'adepts'];
      keys_param.forEach((key) => {
        this.queryParam[key] = '';

        if (this['selected_' + key].length > 0) {
          if (key == 'industrys') {
            let industrys = [];
            this.selected_industrys.forEach((item) => {
              industrys.push(item[1]);
            });
            this.queryParam[key] = industrys.join(',');
          } else {
            this.queryParam[key] = this['selected_' + key].join(',');
          }
        }
      });
      this.$axios
        .post(`${process.env.BASE_URL}api/user/expertList`, this.queryParam)
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.page.list;
            this.total = res.data.page.totalCount;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换模块
    changeModel(model) {
      this.selectedModel = model;
      if (model.expert) {
        this.selectedExpert = model.expert;
      } else {
        this.selectedExpert = {};
      }
    },
    // 选择专家
    rowClick(item) {
      console.log(`🚀 ~ item:`, item);
      //       console.log(`🚀 ~ this.selected_experts:`, this.selected_experts)
      // debugger
      if (this.selected_experts.indexOf(item) > -1) {
        return false;
      } else {
        if (this.selectedModel.expert) {
          this.selected_experts = this.selected_experts.filter((expert) => expert !== this.selectedExpert);
        }
        // console.log(`🚀 ~ workPhoto:`, workPhoto);

        if (item.workPhoto && item.workPhoto.indexOf('"url":') > -1) {
          item.workPhoto = JSON.parse(item.workPhoto);
          item.workPhoto = item.workPhoto[0].url;
        }
        this.detailItem.modelList.forEach((model) => {
          if (this.selectedModel.id == model.id) {
            this.$set(model, 'expert', item);
          }
        });
        this.$set(this.selectedModel, 'expert', item);
        this.$set(item, 'moduleId', this.selectedModel.id);
        this.selected_experts.push(item);
        this.selectedExpert = item;
      }
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getTableData();
    },
    // 列表-排序
    handleSortChange(column) {
      let sortParam = ['ageOrder', 'rankOrder', 'frequencyOrder'];
      let tableParam = ['age', 'rank', 'number'];
      // 清空参数
      sortParam.forEach((p) => {
        this.$delete(this.queryParam, p);
      });
      // 放置排序参数
      if (column.order) {
        let order = 1;
        if (column.order == 'descending') {
          order = 2;
        }
        this.$set(this.queryParam, sortParam[tableParam.indexOf(column.prop)], order);
      }
      // 刷新列表
      this.queryParam.page = 1;
      this.getTableData();
    },
    setMain() {
      if (this.selectedModel.expert) {
        this.selectedMain = this.selectedModel.expert;
      }
      // console.log(`🚀 ~ this.selectedModel.expert:`, this.selectedModel.expert)
    },
    //
    // 确认分配
    submitDistribution() {
      if (!this.selected_experts.length || this.selected_experts.length != this.detailItem.modelList.length) {
        this.$message.warning('请选择专家进行分配');
      } else if (!this.selectedMain.id) {
        this.$message.warning('请选择主审专家');
      } else {
        this.$msgbox({
          title: '分配专家',
          message: `是否确认分配专家？`,
          showCancelButton: true,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              let that = this;
              // recordId,userId
              this.selected_experts.forEach((expert) => {
                this.$set(expert, 'recordId', this.$route.query.recordId);
                this.$set(expert, 'userId', expert.id);
                this.$set(expert, 'isChiefReviewer', 2);
                this.$set(expert, 'moduleId', expert.moduleId);
                if (expert.id == this.selectedMain.id) {
                  this.$set(expert, 'isChiefReviewer', 1);
                }
              });
              this.$axios
                .post(`${process.env.BASE_URL}api/reviewRecord/distributionSpecialist`, this.selected_experts)
                .then((res) => {
                  if (res.data.code == 200) {
                    that.$message({
                      message: '已分配',
                      type: 'success',
                    });
                    this.$router.go(-1);
                  } else {
                    that.$message({
                      message: res.data.msg,
                      type: 'error',
                    });
                  }
                  //确认弹窗还原&关闭
                  instance.confirmButtonText = '确定';
                  instance.confirmButtonLoading = false;
                  done();
                })
                .catch(() => {
                  //确认弹窗还原&关闭
                  instance.confirmButtonText = '确定';
                  instance.confirmButtonLoading = false;
                  done();
                });
            } else {
              //确认弹窗还原&关闭
              instance.confirmButtonText = '确定';
              instance.confirmButtonLoading = false;
              done();
            }
          },
        })
          .then((action) => {})
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
              offset: 100,
            });
          });
      }
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == 'ascending' || header.column.order == 'descending') {
        return { color: '#3D7BDC', fontSize: '14px', fontWeight: 400 };
      } else {
        return { color: '#617180', fontSize: '14px', fontWeight: 400 };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: '14px',
        color: '#111928',
        fontWeight: 500,
        padding: '8px 0px',
      };
    },
  },
};
</script>
<style lang="less" scoped>
#distributionSpecialist {
  box-sizing: border-box;
  position: relative;
  .overhad {
    overflow: auto;
    height: calc(100vh - 100px);
  }
}
.info {
  padding: 10px 0px;
  border-bottom: 1px solid #c0c4cc;
  > div {
    margin-bottom: 10px;
    > div:first-child {
      margin-right: 100px;
    }
  }
}
.card_model {
  position: relative;
  margin: 10px;
  padding: 15px;
  border-radius: 6px;
  background-color: rgba(245, 245, 246, 1);
  cursor: pointer;
  .flexStart {
    flex-wrap: nowrap;
    > div {
      max-width: 80%;
    }
  }
  .title {
    margin-bottom: 10px;
  }
  .gray {
    font-size: 13px;
  }
  img {
    width: 40px;
    height: 40px;
    border-radius: 20%;
    margin-right: 10px;
  }
}
.active {
  background-color: rgba(1, 112, 242, 0.12);
  border: 1px solid rgba(1, 112, 242, 1);
  .blacklogo {
    margin-right: 10px;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 20%;
  }
  .blue_tips {
    font-size: 13px;
  }
}
.main {
  position: absolute;
  right: 0;
  top: 0;
  width: 68px;
  height: 27px;
  border-radius: 6px;
  background-color: rgba(223, 81, 81, 0.3);
  font-size: 13px;
  color: #df5151;
  font-weight: bolder;
  text-align: center;
  line-height: 27px;
}
.checkedIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3e7bfa;
  color: #ffffff;
  i {
    font-weight: bolder;
  }
}
.grayIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(183, 187, 194, 1);
}
.content {
  // margin-bottom: 100px;
  width: calc(100% - 6px);
  > .el-col {
    padding: 10px;
    box-sizing: border-box;
    // height: calc(100vh - 280px);
  }
}
.opts_table {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .el-select {
    width: 120px;
  }
  .el-select,
  .el-input {
    margin: 0px 5px;
    // min-width: 160px;
    // width: fit-content;
  }
  /deep/.el-select-dropdown__list {
    padding: 2px 0px 10px 0px;
  }
  /deep/.el-select-dropdown__item {
    font-size: 12px;
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-scrollbar {
    overflow: hidden;
    // min-height: 100px;
  }
}

.btns_tab {
  width: 265px;
  display: flex;
  margin-top: 23px;
  margin-bottom: 17px;
  padding: 4px;
  font-weight: 500;
  border-radius: var(--rounded-md, 6px);
  border: 1px solid rgba(229, 231, 235, 0.8);
  background: var(--gray-100, #f3f4f6);
  div {
    width: 50%;
    text-align: center;
    cursor: pointer;
    line-height: 150%;
    padding: 4px;
  }
  .active {
    border-radius: var(--rounded-md, 6px);
    background: var(--gray-700, #374151);
    color: #ffffff;
  }
}
</style>
